"use client";

import { useEffect, useState } from "react";
import { Box, Fade } from "@mui/material";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

const ButtonToStart = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    const reduced = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    )?.matches;
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 200);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Fade in={isVisible}>
      <Box
        component="button"
        type="button"
        onClick={scrollToTop}
        aria-hidden={!isVisible}
        tabIndex={isVisible ? 0 : -1}
        sx={{
          position: "fixed",
          bottom: { xs: "1rem", md: "1.5rem" },
          right: { xs: "1rem", md: "1.5rem" },
          zIndex: 1200,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1px",
          width: "2.75rem",
          height: "2.75rem",
          p: 0,
          cursor: "pointer",
          fontFamily: FONT_UI,
          borderRadius: 0,
          border: "1px solid",
          borderColor: "custom.ruleHairline",
          borderTopWidth: "2px",
          borderTopColor: "custom.link",
          backgroundColor: "custom.newsprintRaised",
          color: "custom.link",
          boxShadow: "0 6px 18px rgba(0,0,0,0.14)",
          transition: "background-color .2s ease, color .2s ease",
          "&:hover": {
            backgroundColor: "primary.main",
            borderColor: "primary.main",
            color: "custom.inverted",
          },
        }}
      >
        <Box
          component="span"
          aria-hidden="true"
          sx={{ fontSize: "0.875rem", lineHeight: 1 }}
        >
          ↑
        </Box>
        <Box
          component="span"
          sx={{
            fontSize: "0.5625rem",
            fontWeight: 700,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            lineHeight: 1,
          }}
        >
          Top
        </Box>
      </Box>
    </Fade>
  );
};

export default ButtonToStart;
